export const joinProperties = (...parts: Array<string | undefined>) =>
  parts.filter(Boolean).join('.')
